module.exports = __webpack_public_path__ + "static/img/illustratepic_01.c9c6c11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/illustratepic_01.png
// module id = JpjK
// module chunks = 1